export default class ModulosComplementares {
  public triagemAtiva: boolean;

  public memedAtiva: boolean;

  public sumarioLongitudinalAtiva: boolean;

  public cidAutoAtiva: boolean;

  public scribeAtiva: boolean;

  public drugInteractionAtiva: boolean;

  public carePathwaysAtiva: boolean;

  public buscaGlobalAtiva: boolean;

  public cartaEncaminhamentoAtiva: boolean;

  public noShowPredictionAtiva: boolean;

  public whatsAppAtiva: boolean;

  public telemedicinaAtiva: boolean;

  constructor() {
    this.triagemAtiva = false;
    this.memedAtiva = false;
    this.sumarioLongitudinalAtiva = false;
    this.cidAutoAtiva = false;
    this.scribeAtiva = false;
    this.drugInteractionAtiva = false;
    this.carePathwaysAtiva = false;
    this.buscaGlobalAtiva = false;
    this.cartaEncaminhamentoAtiva = false;
    this.noShowPredictionAtiva = false;
    this.whatsAppAtiva = false;
    this.telemedicinaAtiva = false;
  }
}
